var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-action-field d-flex justify-center align-center",style:({
    '--highlight': _vm.buttonConfig.highlightColor,
    '--solid': _vm.buttonConfig.solidColor,
  })},[_c('BaseButton',{attrs:{"disabled":_vm.isDisabled,"type":_vm.buttonConfig.style,"icon":_vm.buttonConfig.icon,"data-cy":("action-" + _vm.action)},on:{"click":function($event){return _vm.onActionClick(_vm.action)}}},[_vm._v(" "+_vm._s(_vm.buttonConfig.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }